import React from "react";
import TabPanel, { Item } from "devextreme-react/tab-panel";
import Detail from "./Detail";
import Insurance from "./Insurance";
import Payment from "./Payment";
import Education from "./Education";
import Foreigner from "./Foreigner";
import Health from "./Health";
import Others from "./Others";
import "./style.scss";
import { formatMessage } from "devextreme/localization";

export default function TabApprovalSetting({ convertDateTime, employee }) {
  return (
    <TabPanel focusStateEnabled={false} className="mt-1 tab-panel-employee">
      <Item title={formatMessage("Detail")}>
        <Detail employee={employee} convertDateTime={convertDateTime} />
      </Item>
      <Item title={formatMessage("Insurance")}>
        <Insurance convertDateTime={convertDateTime} employee={employee} />
      </Item>
      <Item title={formatMessage("Payment")}>
        <Payment employee={employee} />
      </Item>
      <Item title={formatMessage("Education")}>
        <Education employee={employee} />
      </Item>
      <Item title={formatMessage("Foreigner")}>
        <Foreigner employee={employee} convertDateTime={convertDateTime} />
      </Item>
      <Item title={formatMessage("Health")}>
        <Health employee={employee} />
      </Item>

      <Item title={formatMessage("Other")}>
        <Others employee={employee} />
      </Item>
    </TabPanel>
  );
}
